import React from "react";
import { Link } from "react-router-dom";

const ACCENT = "rgb(var(--c-accent))";

function NotFoundPage() {
  return (
    <div className="min-h-screen w-full bg-surface-2 flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {/* Left: message */}
        <div className="order-2 md:order-1">
          <div className="mb-6">
            <span
              className="inline-block rounded-full px-3 py-1 text-xs font-semibold border"
              style={{ borderColor: ACCENT, color: ACCENT }}
            >
              404 • Not Found
            </span>
          </div>

          <h1 className="text-3xl md:text-4xl font-semibold text-ink">
            You seem to be lost
          </h1>
          <p className="mt-3 text-muted">
            The page you’re looking for isn’t available. It might have been moved
            or deleted. Try searching again, or go back to the dashboard.
          </p>

          <div className="mt-8 flex justify-center w-full flex-wrap gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center h-11 rounded-lg px-5 text-white font-medium"
              style={{ backgroundColor: ACCENT }}
            >
              Go back home
            </Link>
            <Link
              to="/"
              className="inline-flex items-center justify-center h-11 rounded-lg px-5 border font-medium text-ink bg-surface"
              style={{ borderColor: "#E5E7EB" }}
            >
              Contact support
            </Link>
          </div>
        </div>

        {/* Right: illustration card */}
        <div className="order-1 md:order-2">
          <div className="bg-surface border border-line rounded-2xl shadow-sm p-6">
            {/* Replace the placeholder below with your SVG if you like */}
            {/* Example: keep your large SVG here for brand flavor */}
            <div className="aspect-[4/3] w-full rounded-xl bg-surface-2 grid place-items-center">
              <svg
                width="160"
                height="80"
                viewBox="0 0 160 80"
                xmlns="http://www.w3.org/2000/svg"
              >
                <text
                  x="0"
                  y="55"
                  fontFamily="Inter, system-ui, -apple-system, Segoe UI, Roboto"
                  fontSize="64"
                  fontWeight="700"
                  fill={ACCENT}
                >
                  404
                </text>
              </svg>
            </div>

            <div className="mt-4 flex items-center justify-between">
              <div className="text-sm text-muted">
                Error code <span className="font-medium text-ink">404</span>
              </div>
              <div
                className="h-2 w-24 rounded-full"
                style={{ background: `linear-gradient(90deg, ${ACCENT} 0%, #0F2028 100%)` }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
